module.exports = __webpack_public_path__ + "static/assets/9c0786e87df4a8dd25890d9d653d449e.png";